// Backward-compat shim: re-export the canonical chapter list (now defined
// with richer fields in `chaptersData.js`) under the old names used by
// TutorialSidebar / ChapterShell.
import { CHAPTERS as BASE, getChapterById } from "@/tutorial/chaptersData";

export const CHAPTERS = BASE;
export const CHAPTER_BY_ID = Object.fromEntries(
  BASE.map((c) => [String(c.id), c])
);

export function getChapter(id) {
  return getChapterById(id);
}

export function getNeighbours(id) {
  const n = Number(id);
  return { prev: getChapterById(n - 1), next: getChapterById(n + 1) };
}
